/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:48:37
 * @LastEditors: zerui.yao
 * @LastEditTime: 2022-12-10 16:48:52
 * @Description: FileDescription
 */

import db from '@/api/dbWeb';

const model = {
  // 获取应用列表
  getAppList(param) {
    return db.post('/app/search', param);
  },
  // 创建应用
  createApp(param) {
    return db.post('/app/create', param);
  },
  // 获取应用详情
  getAppDetailFun(param) {
    return db.get('/app/detail', param);
  },
  // 更新应用详情
  updateApp(param) {
    return db.post('/app/update', param);
  },
 
};
export default model;
